<p>We will send an email to <strong>{{ _user?.email }}</strong> to reset password.</p>